export function gameAuthHeaders() {
  try { const secret = localStorage.getItem('secret'); return secret ? { Authorization: `Bearer ${secret}` } : {}; }
  catch { return {}; }
}
let stripeScript;
function loadStripe() {
  if (window.Stripe) return Promise.resolve();
  if (!stripeScript) stripeScript = new Promise((resolve, reject) => {
    const script = document.createElement('script'); script.src = 'https://js.stripe.com/v3/';
    script.onload = resolve; script.onerror = () => { script.remove(); stripeScript = null; reject(Error('Secure checkout could not load. Please retry.')); };
    document.head.append(script);
  });
  return stripeScript;
}
async function api(url, body) {
  const response = await fetch(url, { method: body ? 'POST' : 'GET', headers: { ...gameAuthHeaders(), 'Content-Type': 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
  const data = await response.json();
  if (!response.ok || data.error) throw Error(data.message || data.error || 'Please try again.');
  return data;
}
export function setupGameSubscription(root, { pause, enable }) {
  const $ = id => root.querySelector(`#cg-pro-${id}`), dialog = root.querySelector('#cg-pro');
  let checkout, generation = 0, busy = false;
  const status = text => { $('status').textContent = text; };
  function destroy() { checkout?.destroy(); checkout = null; $('checkout').replaceChildren(); }
  dialog.addEventListener('close', () => { generation++; busy = false; destroy(); $('pay').disabled = false; root.querySelector('#cg-super-easy').focus(); });
  $('close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', e => { const b = dialog.getBoundingClientRect(); if (e.target === dialog && (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom)) dialog.close(); });
  root.querySelector('#cg-super-easy').addEventListener('click', () => {
    pause(); dialog.showModal(); status(''); $('auth').hidden = true; $('pay').hidden = false;
    $('pay').textContent = 'Sign in or create account';
  });
  async function begin() {
    if (busy) return;
    busy = true; $('pay').disabled = true;
    const version = ++generation;
    try {
      status('Checking your account…');
      const session = await api('/api/session');
      if (version !== generation) return;
      if (!session.user) { $('auth').hidden = false; $('pay').hidden = true; status(''); $('email').focus(); return; }
      if (session.user.is_subscribed) { dialog.close(); enable(); return; }
      if (!root.dataset.stripeKey) throw Error('Checkout is unavailable right now. Please try again later.');
      status('Preparing secure checkout…');
      await loadStripe();
      if (version !== generation) return;
      const data = await api('/create-checkout-session-embedded', { subscription_type: $('plan').value, inline: true });
      if (version !== generation) return;
      if (!data.clientSecret) throw Error('Checkout could not start. Please retry.');
      destroy();
      const instance = await window.Stripe(root.dataset.stripeKey).initEmbeddedCheckout({
        clientSecret: data.clientSecret,
        onComplete: async () => {
          if (version !== generation) return;
          status('Confirming your subscription…');
          try {
            const verified = await api(`/api/verify-subscription${data.sessionId ? '?session_id=' + encodeURIComponent(data.sessionId) : ''}`, {});
            if (version !== generation) return;
            if (!verified.is_subscribed) throw Error('Payment received. Activation is pending; click activate again shortly.');
            dialog.close(); enable();
          } catch (error) { if (version === generation) { destroy(); $('pay').hidden = false; status(error.message); } }
        }
      });
      if (version !== generation) { instance.destroy(); return; }
      checkout = instance; checkout.mount('#cg-pro-checkout'); $('auth').hidden = true; $('pay').hidden = true; status('');
    } catch (error) { if (version === generation) status(error.message); }
    finally { if (version === generation) { busy = false; $('pay').disabled = false; } }
  }
  $('pay').addEventListener('click', begin);
  function showPrice() {
    const annual = $('plan').value === 'annual';
    const raw = Number($('plan').dataset[annual ? 'annual' : 'monthly']);
    const amount = Number.isFinite(raw) && raw > 0 ? raw : annual ? 390 : 39;
    $('price').textContent = `$${amount.toLocaleString('en-US')}`;
    $('period').textContent = annual ? 'USD / year' : 'USD / month';
    $('billing').textContent = annual ? 'Billed annually. Save $78. Cancel anytime.' : 'Billed monthly. Cancel anytime.';
  }
  showPrice();
  $('plan').addEventListener('change', () => { showPrice(); generation++; busy = false; destroy(); $('pay').hidden = false; $('pay').disabled = false; status(''); });
  $('auth').addEventListener('submit', async e => {
    e.preventDefault(); if (busy) return;
    busy = true; const version = generation;
    const buttons = [...$('auth').querySelectorAll('button')]; buttons.forEach(b => { b.disabled = true; });
    try {
      const email = $('email').value, password = $('password').value;
      if (e.submitter?.name === 'signup') {
        if (password.length < 8) throw Error('Use at least 8 characters for your password.');
        status('Creating your account…'); await api('/api/signup', { email, password });
      }
      status('Signing in…');
      const response = await fetch('/api/login', { method: 'POST', body: new URLSearchParams({ email, password }) });
      const data = await response.json();
      if (!response.ok || !data.success) throw Error(data.message || 'Sign-in failed. Please check your details.');
      if (data.user?.secret) { try { localStorage.setItem('secret', data.user.secret); } catch { /* Session cookie is also supported. */ } }
      $('password').value = '';
      if (version !== generation) return;
      $('auth').hidden = true; $('pay').hidden = false; busy = false; await begin();
    } catch (error) { if (version === generation) status(error.message); }
    finally { if (version === generation) busy = false; buttons.forEach(b => { b.disabled = false; }); }
  });
}
